import React, {FC} from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import {Field, ErrorMessage} from 'formik'
import {useIntl} from 'react-intl'

const Step2: FC = () => {
  const intl = useIntl()

  return (
    <div className='w-100'>
      {/*<div className='pb-10 pb-lg-15'>
        <h2 className='fw-bolder text-dark'>Account Info</h2>

        <div className='text-gray-400 fw-bold fs-6'>
          If you need more info, please check out
          <a href='/' className='link-primary fw-bolder'>
            {' '}
            Help Page
          </a>
          .
        </div>
      </div>*/}

      <div className='mb-10 fv-row'>
        <label className='form-label mb-3'>{intl.formatMessage({id: 'AUTH.REGISTER.BUSINESS_NAME'})}</label>

        <Field
          type='text'
          className='form-control form-control-lg form-control-solid'
          name='business_name'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage name='business_name' />
        </div>
      </div>

      <div className='mb-10 fv-row'>
        <label className='form-label mb-3'>{intl.formatMessage({id: 'AUTH.REGISTER.CONTACT_NAME'})}</label>

        <Field
          type='text'
          className='form-control form-control-lg form-control-solid'
          name='contact_name'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage name='contact_name' />
        </div>
      </div>

      <div className='mb-10 fv-row'>
        <label className='form-label mb-3'>{intl.formatMessage({id: 'AUTH.REGISTER.CONTACT_PHONE'})}</label>

        <Field
          type='text'
          className='form-control form-control-lg form-control-solid'
          name='contact_phone'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage name='contact_phone' />
        </div>
      </div>

      <div className='mb-10 fv-row'>
        <label className='form-label mb-3'>{intl.formatMessage({id: 'AUTH.REGISTER.CONTACT_EMAIL'})}</label>

        <Field
          type='text'
          className='form-control form-control-lg form-control-solid'
          name='contact_email'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage name='contact_email' />
        </div>
      </div>

      <div className='mb-10 fv-row'>
        <label className='d-flex align-items-center form-label mb-3'>
          {intl.formatMessage({id: 'AUTH.REGISTER.BUSINESS_TYPE'})}
        </label>
        <div className='text-danger mt-2'>
          <ErrorMessage name='business_type' />
        </div>

        <div className='row mb-2' data-kt-buttons='true'>
          <div className='col'>
            <Field
              type='radio'
              className='btn-check'
              name='business_type'
              value='realestate'
              id='kt_account_team_size_select_1'
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
              htmlFor='kt_account_team_size_select_1'
            >
              <span className='fw-bolder fs-3'>{intl.formatMessage({id: 'AUTH.REGISTER.TYPE_REALESTATE'})}</span>
            </label>
          </div>
          <div className='col'>
            <Field
              type='radio'
              className='btn-check'
              name='business_type'
              value='hr'
              id='kt_account_team_size_select_2'
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
              htmlFor='kt_account_team_size_select_2'
            >
              <span className='fw-bolder fs-3'>{intl.formatMessage({id: 'AUTH.REGISTER.TYPE_HR'})}</span>
            </label>
          </div>
          <div className='col'>
            <Field
              type='radio'
              className='btn-check'
              name='business_type'
              value='cars'
              id='kt_account_team_size_select_3'
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
              htmlFor='kt_account_team_size_select_3'
            >
              <span className='fw-bolder fs-3'>{intl.formatMessage({id: 'AUTH.REGISTER.TYPE_CARS'})}</span>
            </label>
          </div>
          <div className='col'>
            <Field
              type='radio'
              className='btn-check'
              name='business_type'
              value='short-term-rental'
              id='kt_account_team_size_select_4'
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
              htmlFor='kt_account_team_size_select_4'
            >
              <span className='fw-bolder fs-3'>{intl.formatMessage({id: 'AUTH.REGISTER.TYPE_SHORT_TERM_RENTAL'})}</span>
            </label>
          </div>
          <div className='col'>
            <Field
              type='radio'
              className='btn-check'
              name='business_type'
              value='other'
              id='kt_account_team_size_select_5'
            />
            <label
              className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
              htmlFor='kt_account_team_size_select_5'
            >
              <span className='fw-bolder fs-3'>{intl.formatMessage({id: 'AUTH.REGISTER.TYPE_OTHER'})}</span>
            </label>
          </div>

        </div>
      </div>

      <div className='mb-10 fv-row'>
        <label className='form-label mb-3'>{intl.formatMessage({id: 'AUTH.REGISTER.INVOICE_NAME'})}</label>

        <Field
          type='text'
          className='form-control form-control-lg form-control-solid'
          name='invoice_name'
        />
        <div className='text-danger mt-2'>
          <ErrorMessage name='invoice_name' />
        </div>
      </div>

      {/*<div className='mb-0 fv-row'>
        <label className='d-flex align-items-center form-label mb-5'>
          Select Account Plan
          <i
            className='fas fa-exclamation-circle ms-2 fs-7'
            data-bs-toggle='tooltip'
            title='Monthly billing will be based on your account plan'
          ></i>
        </label>

        <div className='mb-0'>
          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='symbol symbol-50px me-6'>
                <span className='symbol-label'>
                  <KTSVG
                    path='/media/icons/duotune/finance/fin001.svg'
                    className='svg-icon-1 svg-icon-gray-600'
                  />
                </span>
              </span>

              <span className='d-flex flex-column'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>
                  Company Account
                </span>
                <span className='fs-6 fw-bold text-gray-400'>
                  Use images to enhance your post flow
                </span>
              </span>
            </span>

            <span className='form-check form-check-custom form-check-solid'>
              <Field className='form-check-input' type='radio' name='accountPlan' value='1' />
            </span>
          </label>

          <label className='d-flex flex-stack mb-5 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='symbol symbol-50px me-6'>
                <span className='symbol-label'>
                  <KTSVG
                    path='/media/icons/duotune/graphs/gra006.svg'
                    className='svg-icon-1 svg-icon-gray-600'
                  />
                </span>
              </span>

              <span className='d-flex flex-column'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>
                  Developer Account
                </span>
                <span className='fs-6 fw-bold text-gray-400'>Use images to your post time</span>
              </span>
            </span>

            <span className='form-check form-check-custom form-check-solid'>
              <Field className='form-check-input' type='radio' name='accountPlan' value='2' />
            </span>
          </label>

          <label className='d-flex flex-stack mb-0 cursor-pointer'>
            <span className='d-flex align-items-center me-2'>
              <span className='symbol symbol-50px me-6'>
                <span className='symbol-label'>
                  <KTSVG
                    path='/media/icons/duotune/graphs/gra008.svg'
                    className='svg-icon-1 svg-icon-gray-600'
                  />
                </span>
              </span>

              <span className='d-flex flex-column'>
                <span className='fw-bolder text-gray-800 text-hover-primary fs-5'>
                  Testing Account
                </span>
                <span className='fs-6 fw-bold text-gray-400'>
                  Use images to enhance time travel rivers
                </span>
              </span>
            </span>

            <span className='form-check form-check-custom form-check-solid'>
              <Field className='form-check-input' type='radio' name='accountPlan' value='3' />
            </span>
          </label>
        </div>
      </div>*/}
    </div>
  )
}

export {Step2}
